export const auth = {
  btn_login: "Log in",
  btn_forgot_password: "Forgot password?",
  btn_trigger_password_reset: "Reset password",

  pw_error_digit: "Use at least one digit (0-9)",
  pw_error_lowercase: "Use at least one lowercase letter (a-z)",
  pw_error_uppercase: "Use at least one uppercase letter (A-Z)",
  pw_error_whitespace: "Do not use whitespace characters",
  pw_error_length: "Use minimum 8 characters",

  forgot_password_head: "Forgot your password",
  forgot_password_info:
    "Fill in your email address and press the Reset Password button. You will receive an email with a reset link.",

  login_head: "Log in",
  login_info: "Fill in your email address and password.",

  login_error: "Something went wrong during login, please try again later.",

  reset_password_head: "Password Reset",
  reset_password_info:
    "Use at least:\n• 8 characters\n• 1 uppercase letter\n• 1 number",

  trigger_pw_reset_error:
    "Something went wrong during password reset, please try again later.",

  trigger_pw_reset_head: "Reset Password",
  trigger_pw_reset_response:
    "If your account was found, an email has now been sent with a password reset link.",

  pw_reset_head: "Save New Password",
  pw_reset_response: "Your new password has been saved.",
  pw_reset_error:
    "Something went wrong during password reset, please try again later.",
};
